import { render, staticRenderFns } from "./check-info.vue?vue&type=template&id=a13f792a&scoped=true&"
import script from "./check-info.vue?vue&type=script&lang=js&"
export * from "./check-info.vue?vue&type=script&lang=js&"
import style0 from "./check-info.vue?vue&type=style&index=0&id=a13f792a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13f792a",
  null
  
)

export default component.exports